module.exports = __webpack_public_path__ + "static/img/home_product3.0fa6dac5.png";